module.exports = __webpack_public_path__ + "static/reunion-logo-165f14ad71c050e393e1ad3de59a9843.png";